// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Header_wrap__3TDpK","title":"Header_title__35o7z","button":"Header_button__2G3Tb","icon":"Header_icon__3YNVX"};